import React, { useEffect, useState } from 'react';
// import { FaArrowCircleUp } from 'react-icons/fa';

const ScrollToTopModal: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;

      if (scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <div className="fixed bottom-4 right-4 z-50">
          <button
            onClick={scrollToTop}
            className="bg-[#17191c] hover:bg-[#33373c] text-[#f1d8a7] rounded-full font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
          >
            {/* <FaArrowCircleUp className="inline-block mr-2" /> */}
            ^
          </button>
        </div>
      )}
    </>
  );
};

export default ScrollToTopModal;
